import axios from 'axios';
import firebase from 'firebase/app';
import Vue from 'vue';
import Vuex from 'vuex';
import router from '../router';


const requestWithIdToken = (callback) => {
  firebase
    .auth()
    .currentUser.getIdToken()
    .then((idToken) => {
      callback(idToken)
    })
    .catch((error) => console.log("error", error));
}

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    catalog: [],
    apps: {},
    catalogManagerUrl: 'https://catalog-manager.cdwapi.com'
    //catalogManagerUrl: 'http://localhost:5001'
  },
  mutations: {
    SET_APPS(state, apps) {
      state.apps = apps;
    },
    SET_USER(state, payload) {
      state.user = payload;
      if (payload){
        if (router.currentRoute.name == 'Signin'){
          router.replace({name: "Home"})
        }
      }else{
        if (router.currentRoute.name != 'Signin'){
          router.replace({name: "Signin"})
        }
      }
    },
    SET_CATALOG(state, payload){
      state.catalog = payload
    }
  },
  actions: {
    fetchApps({ commit }) {
      try {
        console.log("requestig with id token");
        requestWithIdToken((idToken) => {
          axios
            .get(`${this.state.catalogManagerUrl}/apps`, {
              headers: { authorization: idToken },
            })
            .then((res) => {
              commit("SET_APPS", res.data.payload);
            }).catch((error) => {
              console.log("Error fetching apps: ", error);
            });
        });
      } catch (error) {
        console.error("Error fetching apps: ", error);
      }
    },
    setUser({ commit, dispatch }, user) {
      dispatch("fetchApps");
      if (user) {
        commit("SET_USER", {
          displayName: user.displayName,
          email: user.email
        });
        dispatch('fetchCatalog')
      } else {
        commit("SET_USER", null);
      }
    },
    fetchCatalog({ commit, state }) {
      requestWithIdToken((idToken) => {
        axios
          .get(
            state.catalogManagerUrl+"/whole-catalog",
            { headers: { authorization: idToken }}
          )
          .then((res) => {
            commit('SET_CATALOG', res.data.payload)
          });
      })
    },
    updateCatalog({ dispatch, state }, payload) {
      requestWithIdToken((idToken) => {
        axios
          .post(
            state.catalogManagerUrl + "/update", 
            payload, 
            { headers: { authorization: idToken }}
          ).then((res) => {
            if (res.data.status.code == 200) {
              dispatch('fetchCatalog')
            } else {
              console.log("error on submit", res.data);
            }
          });
      })
    },
    deleteProduct({ dispatch, state }, payload){
      requestWithIdToken((idToken) => {
        axios
          .post(
            state.catalogManagerUrl + "/delete", 
            {id: payload}, 
            { headers: { authorization: idToken }}
          ).then((res) => {
            if (res.data.status.code == 200) {
              dispatch('fetchCatalog')
            } else {
              console.log("error on submit", res.data);
            }
          });
      })
    }
  },
  getters: {
    user(state){
      return state.user
    },
    catalog(state){
      return state.catalog
    },
    apps(state) {
      const apps = state.apps
      const sortedObj = Object.fromEntries(
        Object.entries(apps).sort(([, val1], [, val2]) => val1.localeCompare(val2))
      );
      return sortedObj;
    }
  }
})
